import { render, staticRenderFns } from "./CourseDetailsDialog.vue?vue&type=template&id=097a5e32&"
import script from "./CourseDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/buttons/ButtonPrimary.vue').default,Modal: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/Modal.vue').default})
